// import axios from 'axios'
var _ = require('underscore')

const filter = {
  // cpv: {
  //     type: 'number',
  // },
  date: {
    type: 'number',
    regex: [',', '.', '-'],
  },
  status: {
    type: 'string',
    regex: ['active', 'canceled', 'complete'],
  },
  title: {
    type: 'string',
  },
  identifier: {
    type: 'number',
  },
}

// const digits_only = string => [...string].every(c => '0123456789.,-'.includes(c));
// console.log(digits_only('01,02,f2019'));

// (new Date(searchPhrase) !== "Invalid Date") && !isNaN(new Date(searchPhrase))
// Check: string is Date

export default {
  filter(searchPhrase) {
    searchPhrase = searchPhrase.toLowerCase()
    let filterSuit = []
    const digits_only = (string) => [...string].every((c) => '0123456789.,-/'.includes(c))
    const cpvRegexp = /\d{8}-\d/

    if (
      digits_only(searchPhrase) &&
      new Date(searchPhrase) !== 'Invalid Date' &&
      !isNaN(new Date(searchPhrase))
    ) {
      filterSuit = ['title']
      filterSuit.push('date')
    } else if (searchPhrase.trim().indexOf('ua') === 0) {
      filterSuit = ['identifier']
    } else if (cpvRegexp.test(searchPhrase) && digits_only(searchPhrase)) {
      filterSuit = ['cpv']
    } else {
      Object.keys(filter).forEach((filterType) => {
        if (filterType === 'status') {
          if (_.indexOf(filter.status.regex, searchPhrase) !== -1) {
            filterSuit.push(filterType)
          }
        } else {
          if (filter[filterType].type === (typeof searchPhrase).toString().toLocaleLowerCase()) {
            filterSuit.push(filterType)
          }
        }
      })
    }
    return filterSuit
  },
  filterByType(type) {
    //for now we only handle type status
    //but here will be other type depending how it goes
    if (type === 'status') {
      return filter.status.regex
    } else {
      return []
    }
  },
}
